module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapname2"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("s with any published work, authors must depend on a great many people for assistance. These included, over many years, my fellow author and long-time mentor the late Richard Hunnicutt. Other friends who kindly supplied information and pictures for this work are credited in the captions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both the paid and volunteer staff of the now-closed Patton Museum of Armor and Cavalry provided the author with a great deal of assistance over many years. For the sake of brevity all images from the former Patton Museum of Cavalry and Armor will be credited to the ‘Patton Museum’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am also indebted to David Fletcher, fellow author and the long-time former librarian at the Tank Museum located in Bovington, England. He has greatly assisted the author in locating photographs for many of his books. All images from the Tank Museum in Bovington will be credited to just the ‘Tank Museum’ for brevity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A US army entity that assisted the author in acquiring historical photographs of American tanks for this work was the Command Historian’s Office of the TACOM Life Cycle Management Command (LCMC). All pictures from this organization are credited to ‘TACOM’ for the sake of brevity.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c71128","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/teil3.vue
// module id = 72
// module chunks = 0